function getEmbededJson(id: string) {
  const element = document.getElementById(`classic-json-data-${id}`);
  if (element && element.textContent) {
    const jsonData = JSON.parse(element.textContent);
    return jsonData;
  }
}

export { getEmbededJson };
